import {useState, useEffect} from 'react';
import {db} from '../firebase/firebaseConfig';
import { ref, query, onValue,orderByValue,orderByChild,equalTo,limitToFirst,limitToLast,startAt} from "firebase/database";

const useObtenerViajes = (time) => {
    
    const [viajes, cambiarViajes] = useState([]);
    

    useEffect( () => {
        cambiarViajes([]);
        const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados'),orderByChild('estado'),equalTo('Asignado'));
        
        //const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados'));
        console.log("llama base de viajes");
        return onValue(consulta, (snapshot) => {
           snapshot.forEach((childSnapshot) => {
            const childKey = childSnapshot.key;
            const childData = childSnapshot.val();
            cambiarViajes((viajes) => [...viajes, {...childData, id: childKey}]);
            });
          }, 
    {
        onlyOnce: true
      }
    );
   }, [time]);

   useEffect( () => {
    const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados'),orderByChild('estado'),equalTo('Preasignado'));
    
    //const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados'));
    console.log("llama base de viajes");
    return onValue(consulta, (snapshot) => {
       snapshot.forEach((childSnapshot) => {
        const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        cambiarViajes((viajes) => [...viajes, {...childData, id: childKey}]);
        });
      }, 
{
    onlyOnce: true
  }
);
}, [time]);

useEffect( () => {
  const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados'),orderByChild('estado'),equalTo('Programado'));
  
  //const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados'));
  console.log("llama base de viajes");
  return onValue(consulta, (snapshot) => {
     snapshot.forEach((childSnapshot) => {
      const childKey = childSnapshot.key;
      const childData = childSnapshot.val();
      cambiarViajes((viajes) => [...viajes, {...childData, id: childKey}]);
      });
    }, 
{
  onlyOnce: true
}
);
}, [time]);

useEffect( () => {
  const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados'),orderByChild('estado'),equalTo('Activo'));
  
  //const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados'));
  console.log("llama base de viajes");
  return onValue(consulta, (snapshot) => {
     snapshot.forEach((childSnapshot) => {
      const childKey = childSnapshot.key;
      const childData = childSnapshot.val();
      cambiarViajes((viajes) => [...viajes, {...childData, id: childKey}]);
      });
    }, 
{
  onlyOnce: true
}
);
}, [time]);



    return (viajes);

}

export default useObtenerViajes;